module.exports = __webpack_public_path__ + "img/hs_ev_einleitung_10.53b640ae.png";